module.exports = __webpack_public_path__ + "static/media/general.4d50764e.png";